'use client';
import { Ctext } from '@/components/ui/Ctext';
import { ColorType, getColorValue } from '@/theme/colors';
import { FontWeight } from '@/theme/typography';
import { getRadiusCssValue } from '@/theme/radius';
import { pxToRem } from '@/theme/spacing';
import { dataEl, type DataElScope } from '@/utils/dataEl';
import type { ReactElement } from 'react';
import { FakeCommentFileItem } from './FakeCommentFileItem';
import { FAKE_COMMENT_FILE_ACTION_LABELS } from './cfakecommentConstants';
import type { FakeCommentFileAttachment } from './cfakecommentTypes';
interface FakeCommentFileActionContentProps {
    dataElScope: DataElScope;
    message: FakeCommentFileAttachment;
    isMobile: boolean;
}
export function FakeCommentFileActionContent({ dataElScope, message, isMobile, }: FakeCommentFileActionContentProps): ReactElement {
    const actionIdentity = `${message.action}-${message.fileName}`;
    return <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: pxToRem(10),
        }}>
	            <div data-el={dataEl(dataElScope, 'FileAction/Status')} style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: pxToRem(8),
            width: 'fit-content',
            padding: `${pxToRem(5)} ${pxToRem(10)}`,
            borderRadius: getRadiusCssValue(999),
            backgroundColor: 'rgba(102, 254, 193, 0.16)',
            border: '1px solid rgba(102, 254, 193, 0.22)',
            boxShadow: 'rgba(255, 255, 255, 0.08) 0px 1px 0px inset',
        }}>
	                <div style={{
            width: pxToRem(6),
            height: pxToRem(6),
            borderRadius: '50%',
            backgroundColor: getColorValue(ColorType.Accent),
            boxShadow: '0 0 12px rgba(102, 254, 193, 0.45)',
        }}/>
	                <Ctext size={isMobile ? 11 : 12} weight={FontWeight.SemiBold} color={ColorType.Accent} opacity={1} style={{
            lineHeight: 1.2,
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
        }}>
                    {FAKE_COMMENT_FILE_ACTION_LABELS[message.action]}
                </Ctext>
            </div>
            <FakeCommentFileItem dataElScope={dataElScope} message={message} isMobile={isMobile}/>
        </div>
        ;
}
